const restUrl = advSearch.restUrl;

/**
 * API wrapper per ottenere listings
 */
export async function getListings(params) {
  return await requestWrapper(params, "listings");
}

/**
 * API wrapper per ottenere markers
 */
export async function getMarkers(params) {
  return await requestWrapper(params, "markers");
}

/**
 * Funzione generica per effettuare una richiesta POST
 * Restituisce sempre un oggetto { data, error }
 */
async function requestWrapper(body, endpoint, method) {
  try {
    const res = await fetch(`${restUrl}/${endpoint}`, {
      method: method || "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text();
      return {
        data: null,
        error: `HTTP ${res.status} ${endpoint}: ${errorText}`,
      };
    }

    const json = await res.json();

    return { data: json.data, error: null };
  } catch (error) {
    console.error("Request error:", error);
    return { data: null, error: error.message + endpoint };
  }
}
